import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";

import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import {fetchCompanyGroups, findCompaniesByQueryString, isUserAdmin} from "../../utils/requestUtils";
import Config from "../../core/config";
import { usePermission } from "../../core/PermissionContext";
import NewButton from '../common/NewButton';
import TableRowActions from '../common/TableRowActions';
import ListPageLayout from '../common/ListPageLayout';

const apiUrl = Config.apiUrl;
const CompanyList = () => {
    let [companies, setCompanies] = useState([]);
    const [queryString, setQueryString] = useState('');
    const [showDisabled, setShowDisabled] = useState(false);
    const [isAdmin, setIsAdmin] = useState(undefined);
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const { hasUserPermission, loadingPermissions } = usePermission();
    const navigate = useNavigate();

    async function makeQuery(query, disabled) {
        try {
            setLoading(true);
            const enabled = disabled ? false : true;
            const response = await findCompaniesByQueryString(query, enabled);
            setCompanies(response || []);
        } catch (error) {
            console.error('Error fetching data:', error);
            setCompanies([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        isUserAdmin().then(userAdmin => {
            setIsAdmin(userAdmin);
        });
    }, []);

    useEffect(() => {
        if (!loadingPermissions && isAdmin !== undefined && (!isAdmin && !hasUserPermission('LIST_COMPANY'))) {
            navigate('/unauthorizedaccess');
        }
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('', showDisabled);
    }, [loadingPermissions, hasUserPermission, navigate, isAdmin]);

    async function deleteCompany(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/companies/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString, showDisabled);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string, showDisabled);
        }
        setQueryString(string);
    };

    const handleShowDisabledChange = (e) => {
        const checked = e.target.checked;
        setShowDisabled(checked);
        makeQuery(queryString, checked);
    };

    return (
        <ListPageLayout
            tableWidth={580}
            header={
                <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                    <div className="header-label">Consulta de Empresas</div>
                    <NewButton className={"new-button"} onClick={() => navigate(`/${isAdmin ? 'admin' : 'app'}/company`)}/>
                </div>
            }
            filters={
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                    <label style={{marginLeft: '10px', display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap'}}>
                        <input type="checkbox" checked={showDisabled} onChange={handleShowDisabledChange}/>
                        Mostrar desabilitadas
                    </label>
                </div>
            }
        >
            <table>

                <tr>
                    <th>
                        Nome
                    </th>
                    <th>
                        Cidade
                    </th>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {companies?.map((company, index) => (


                    <tr>

                        <td>
                            <div key={index}>{company.name}</div>
                        </td>
                        <td>
                            <div key={index}>{company.city}</div>
                        </td>
                        <td>
                            <TableRowActions
                                actions={[
                                    {
                                        key: 'edit',
                                        label: 'Editar',
                                        type: 'edit',
                                        onClick: () => navigate(`/${isAdmin ? 'admin' : 'app'}/company?id=` + company.id),
                                        buttonProps: {className: 'edit-button'},
                                    },
                                    {
                                        key: 'delete',
                                        label: 'Excluir',
                                        type: 'delete',
                                        onClick: async () => {
                                            if (window.confirm('Deseja realmente excluir?')) {
                                                await deleteCompany(company.id);
                                            }
                                        },
                                    },
                                ]}
                            />
                        </td>

                    </tr>
                ))}
                </tbody>
                {companies?.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>
        </ListPageLayout>
    );
};

export default CompanyList;
